<template>
	<v-spacer v-if="spacer"></v-spacer>
	<v-col v-bind="$attrs" v-else>
		<slot></slot>
	</v-col>
</template>

<script>
export default {
	props: {
		spacer: Boolean,
	},
}
</script>
